import React from 'react';

const FranchisePreview = ({ data }) => {
  const { name, additionalBrandNames } = data.attributes

  return (
    <div className="franchise-preview">
      <div className="franchise-details">
        <div className="name">{ name }</div>
        { additionalBrandNames.map(brandName => (
          <div key={brandName} className="additional-brand">{ brandName }</div>
        ))}
      </div>
    </div>
  )
}

export default FranchisePreview
